<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'

	import stringUtils from "../assets/js/stringUtil.js";
    import { getTemplateInfo,submitProcess,getApproverDetailInfo } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				listLoading: false,
				isDisabled: false,
				formLoading:false
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},

		methods: { //方法
			
			getTemplate:async function() {
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						
						if(item.Property.Title[0].Text == "预交诉讼费承担比例"){
							console.log(item)
							item.Config.Table.Children.forEach(children =>{
								children.Value = 0;
							})
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getApproverDetail() {
				this.listLoading = true;
				getApproverDetailInfo(this.spNo).then(response => {
					var controls = response.Body;
					this.templateData = controls;
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {

				this.$forceUpdate()
			},
			tableOperation(val, type) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, this.templateData.TemplateContent.Controls);
			},
			submit() {
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "预交诉讼费承担比例"})[0];
				var count = 0;
				control.Config.Table.Children.forEach(children =>{
					count += parseFloat(children.Value);
				})
				if(count!=100){
					this.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
						background: true,
						content: '预交诉讼费承担比例之和必须为100%'
					});
					return;
				}
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "委托追佣部门"})[0]
				info.SummaryInfo.push({"Text":"委托追佣部门："+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "委托追佣项目名称"})[0]
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "委托追佣开发商名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"委托追佣项目名称："+control3.Value +"  委托追佣开发商名称:"+ control4.Value   ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "委托追佣金额(元)"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"委托追佣金额(元)："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
